import React from 'react'
// import NavBar from '../NavBar/NavBar'
import './Fany.css'

function Fany() {
  return (
    // <div className='fany' >
    //   <div className='fany_text'>
    //     <h2> طلب فني </h2>
    //   </div>
    //   <div className='fany_input'>
    //     <div className='name'> <label>اسم العميل</label> <input value='' placeholder='ادخل اسمك' type='text'/> </div>
    //     <div className='phone'> <label>رقم الهاتف </label><input value=''  placeholder='ادخل رقم الهاتف' type='tel'/> </div>
    //     <div className='adress'><label> العنوان </label> <input value=''  placeholder='العنوان' type='text'/> </div>
    //     <div className='time'><label> معاد وصول الفني </label> <input value=''  type='date'/> <input type='time'/> </div>
    //     <div className='disc'> <label> وصف المشكله</label> <textarea name="mytextarea" rows="4" cols="30"> اوصف المشكله</textarea> </div>
    //     <button> ارسال الطلب </button>
    //   </div>
    // </div>
    <div className='send_requst' >
      <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSfnlpPydJhGzTv5ac2IGMrfNVj9OpxzJatzOreoJm4LoITPnA/viewform?embedded=true" width="400" height="1221" frameborder="0" marginheight="0" marginwidth="0">جارٍ التحميل…</iframe>
    </div>
  )
}

export default Fany
